import React from "react";
import { Edit2, Trash2 } from "lucide-react";

const IndexRow = ({ user }) => (
  <>
    <td className="px-6 py-4 rounded-l-xl">
      <div className="flex items-center gap-3">
        <img 
          src={user.image} 
          alt={user.name} 
          className="w-10 h-10 rounded-full object-cover border border-stone-200" 
        />
        <div>
          <p className="text-xs font-black text-stone-800 dark:text-white uppercase tracking-tight">
            {user.name}
          </p>
          <p className="text-[10px] text-stone-400 font-medium">{user.email}</p>
        </div>
      </div>
    </td>
    <td className="px-4 py-4 text-[10px] font-black uppercase tracking-widest text-stone-600 dark:text-stone-300">
      {user.role}
    </td>
    <td className="px-4 py-4 text-center">
      <span className={`px-3 py-1 rounded-full text-[9px] font-black uppercase tracking-tighter ${
        user.status === 'Active' ? 'bg-green-100 text-green-600' : 
        user.status === 'Pending' ? 'bg-yellow-100 text-yellow-600' : 'bg-red-100 text-red-600'
      }`}>
        {user.status}
      </span>
    </td>
    <td className="px-4 py-4 text-center text-xs font-medium text-stone-500">
      {user.joined}
    </td>
    <td className="px-6 py-4 rounded-r-xl">
      <div className="flex items-center justify-center gap-2">
        <button className="p-2.5 bg-white/50 hover:bg-blue-100 text-stone-400 hover:text-blue-600 rounded-xl transition-all shadow-sm">
          <Edit2 size={14} />
        </button>
        <button className="p-2.5 bg-white/50 hover:bg-red-100 text-stone-400 hover:text-red-600 rounded-xl transition-all shadow-sm">
          <Trash2 size={14} />
        </button>
      </div>
    </td>
  </>
);

export default IndexRow;